import React from 'react';

// Компонент для отображения медали с местом
const MedalIcon = ({ place }) => {
  const colors = {
    1: { main: '#FFD700', gradient: '#FFA500', shadow: '#B8860B' }, // золото
    2: { main: '#C0C0C0', gradient: '#E8E8E8', shadow: '#808080' }, // серебро
    3: { main: '#CD7F32', gradient: '#E8A87C', shadow: '#8B4513' }  // бронза
  };

  const color = colors[place];

  return (
    <div style={{ display: 'inline-block', width: '32px', height: '32px' }}>
      <svg width="32" height="32" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Определение градиента */}
        <defs>
          <radialGradient id={`medalGradient${place}`} cx="0.3" cy="0.3" r="0.8">
            <stop offset="0%" stopColor={color.gradient} />
            <stop offset="70%" stopColor={color.main} />
            <stop offset="100%" stopColor={color.shadow} />
          </radialGradient>
          <filter id={`shadow${place}`}>
            <feDropShadow dx="0" dy="2" stdDeviation="2" floodOpacity="0.3"/>
          </filter>
        </defs>

        {/* Внешний круг медали с тенью */}
        <circle
          cx="22"
          cy="22"
          r="18"
          fill={`url(#medalGradient${place})`}
          filter={`url(#shadow${place})`}
          stroke={color.shadow}
          strokeWidth="1"
        />

        {/* Внутренний декоративный круг */}
        <circle
          cx="22"
          cy="22"
          r="15"
          fill="none"
          stroke={color.shadow}
          strokeWidth="0.5"
          opacity="0.4"
        />

        {/* Центральный круг для номера */}
        <circle
          cx="22"
          cy="22"
          r="12"
          fill="rgba(255,255,255,0.2)"
        />

        {/* Блик сверху */}
        <ellipse
          cx="18"
          cy="16"
          rx="6"
          ry="4"
          fill="rgba(255,255,255,0.4)"
        />

        {/* Звезда в центре (опционально) */}
        <path
          d="M22,14 L23.5,18.5 L28,18.5 L24.5,21.5 L26,26 L22,23 L18,26 L19.5,21.5 L16,18.5 L20.5,18.5 Z"
          fill={color.shadow}
          opacity="0.3"
        />

        {/* Номер места */}
        <text
          x="22"
          y="27"
          fontSize="16"
          fontWeight="bold"
          fill="#000"
          textAnchor="middle"
        >
          {place}
        </text>
      </svg>
    </div>
  );
};

export default MedalIcon;
